import { tracker } from '.';
import { getState } from '../atoms/helpers';
import { ISegmentExperienceObject, ISegmentInfo, ISegmentSection } from '../interfaces';

function trackContatInfomation(segment_data: ISegmentInfo) {
  tracker.identify({
    userId: '', // anonymous until tutor.uuid is available
    segmentOptions: { anonymousId: segment_data.application_id },
    traits: {
      firstName: 'Test',
      lastName: 'User',
      address: {
        state: getState(segment_data.zip_code?.value),
        postalCode: segment_data.zip_code?.value as string,
        country: segment_data.country?.value as string,
      },
    },
  });
  tracker.track({
    eventName: 'Application contact information submitted',
    segmentOptions: { anonymousId: segment_data.application_id },
    properties: {
      first_name: 'Test',
      last_name: 'User',
      email: segment_data.email?.value,
      phone_number: segment_data.phone_number?.value,
      zip_code: segment_data.zip_code?.value,
      country: segment_data.country?.value,
    },
  });
}

function trackEducationEvent(segment_data: ISegmentInfo) {
  tracker.track({
    eventName: 'Application education information submitted',
    segmentOptions: { anonymousId: segment_data.application_id },
    properties: {
      education: segment_data.education?.value,
    },
  });
}

function trackExperienceEvent(
  segment_data: ISegmentInfo,
  experience_data: ISegmentExperienceObject[],
) {
  const parse_experience_data = experience_data.reduce((acc, experience) => {
    return {
      ...acc,
      ...{
        [experience.label
          .replace(/[^a-zA-Z ]/g, '')
          .replaceAll(' ', '_')
          .toLowerCase()]: experience.value,
      },
    };
  }, {});

  tracker.track({
    eventName: 'Application experience information submitted',
    segmentOptions: { anonymousId: segment_data.application_id },
    properties: parse_experience_data,
  });
}

function trackReviewSubmitEvent(segment_data: ISegmentInfo) {
  tracker.track({
    eventName: 'Application Submitted',
    segmentOptions: { anonymousId: segment_data.application_id },
  });
}

export function trackApplicationAnalysis(
  applicationID: string,
  applicationAnalysisElapsedTime: number,
  provider: string,
  launchDarklyGroup: string,
  tutorId: number | null,
  error: boolean = false,
  errorMessage?: string,
  errorCode?: string,
) {
  tracker.track({
    eventName: 'Application Analysis',
    segmentOptions: { anonymousId: applicationID },
    properties: {
      application_analysis_elapsed_time: applicationAnalysisElapsedTime,
      launch_darkly_group: launchDarklyGroup,
      application_id: applicationID,
      provider: provider,
      tutor_id: tutorId,
      ...(error && { error: true }),
      ...(errorMessage && { error_message: errorMessage }),
      ...(errorCode && { error_code: errorCode }),
    },
  });
}

export const segmentAction = {
  'Contact Information': trackContatInfomation,
  Education: trackEducationEvent,
  Experience: trackExperienceEvent,
  'Review & Submit': trackReviewSubmitEvent,
};

export function trackSubmit(segment_data: ISegmentSection) {
  const { currentSection, answer, experience } = segment_data;
  segmentAction[currentSection](answer, experience);
}
